<script lang="ts" setup>
import AlertMessage from "@/components/messages/AlertMessage.vue";
import { OrderStopState } from "@/constants/order";
import type { TripOrder } from "@/types/trip";
import VerticalDotsButton from "@/components/buttons/VerticalDotsButton.vue";

defineProps<{
  orders: TripOrder[];
}>();

const emit = defineEmits<{
  (e: "add:route"): void;
  (e: "add:order"): void;
  (e: "edit:stopsOrder"): void;
}>();

function isOrderChanged(order: TripOrder): boolean {
  return order.orderStops.some((os) => os.state !== OrderStopState.normal);
}

function addRoute(): void {
  emit("add:route");
}

function addOrder(): void {
  emit("add:order");
}

function editStopsOrder(): void {
  emit("edit:stopsOrder");
}
</script>

<template>
  <div class="trip-block mb-4" data-qa="trip-block-main">
    <div class="trip-block__inner bg-white pa-4 rounded-lg">
      <div class="trip-block__header d-flex align-center justify-space-between mb-3">
        <span class="text-grey-darken-2 font-weight-medium">Trip</span>
        <v-menu offset-y>
          <template #activator="{ props }">
            <vertical-dots-button v-bind="props" />
          </template>
          <v-list>
            <v-list-item @click="addRoute">
              <v-list-item-title data-qa="add-route">Add route</v-list-item-title>
            </v-list-item>
            <v-list-item @click="addOrder">
              <v-list-item-title data-qa="add-order">Add order</v-list-item-title>
            </v-list-item>
            <v-list-item @click="editStopsOrder">
              <v-list-item-title data-qa="edit-stops-order">Edit stops order</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <template v-for="order in orders" :key="order.id">
        <alert-message v-if="isOrderChanged(order)" bg-color="grey-lighten-4" data-qa="update-order-message">
          Order #{{ order.number }} has been changed, please check details below
        </alert-message>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.trip-block__inner {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
